'use client';

import { useEffect, useState } from 'react';
import cx from 'classnames';
import Button from '@/shared/Buttons/Button';
import Modal from '@/shared/Modal/Modal';
import ForgotPassword from '@/widgets/Modals/AuthModal/ForgotPassword/ForgotPassword';
import Register from '@/widgets/Modals/AuthModal/register/Register';
import Login from './login/Login';

import styles from './styles.module.css';

type AuthModalT = {
  type: string;
};

const AuthModal: React.FC<AuthModalT> = ({ type }) => {
  const [mode, setMode] = useState(type);

  useEffect(() => {
    const handleSwitchMode = (event: CustomEvent) => {
      setMode(event.detail);
    };

    window.addEventListener(
      'switchAuthMode',
      handleSwitchMode as EventListener,
    );

    return () => {
      window.removeEventListener(
        'switchAuthMode',
        handleSwitchMode as EventListener,
      );
    };
  }, []);

  return (
    <Modal>
      <div className={styles.wrapper}>
        {mode !== 'forgotPassword' ? (
          <div className={styles.authHead}>
            <Button
              text={'Регистрация'}
              ariaLabel={'Регистрация'}
              onClick={() => {
                setMode('register');
              }}
              color={'transparent'}
              className={cx(
                styles.headerBtn,
                mode === ('register' as string) ? styles.activeBtn : '',
              )}
            />
            <Button
              text={'Авторизация'}
              ariaLabel={'Авторизация'}
              onClick={() => {
                setMode('login');
              }}
              color={'transparent'}
              isActive={mode === ('login' as string)}
              className={cx(
                styles.headerBtn,
                mode === ('login' as string) ? styles.activeBtn : '',
              )}
            />
          </div>
        ) : null}
        {mode === 'register' && <Register />}
        {mode === 'login' && <Login setMode={setMode} />}
        {mode === 'forgotPassword' && <ForgotPassword />}
      </div>
    </Modal>
  );
};

export default AuthModal;
